export const toolIconPaths = {
  seating: "M3 3h18M3 7h4v5H3zM10 7h4v5h-4zM17 7h4v5h-4zM3 16h4v5H3zM10 16h4v5h-4zM17 16h4v5h-4z",
  calendar: "M4 5h16v16H4zM8 2v6M16 2v6M4 10h16M8 14h3M8 18h6",
  import: "M8 7V3h13v18H8v-4M8 7h13M14 7v14M14 12h7M8 17h13M2 12h9m-3-3 3 3-3 3",
  export: "M5 3h8l4 5v3M13 3v5h4M17 19v2H5V3M8 12h2M8 16h2M13 15h9m-3-3 3 3-3 3",
} as const;

export default function ToolIcon({ name }: { name: keyof typeof toolIconPaths }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={toolIconPaths[name]} />
    </svg>
  );
}
